import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TextField } from "@mui/material";
import popupMessage from "../../../services/popupMessage";
import imageUpload from "../../../services/upload";
import { instanceToken } from "../../../utils/constant";
import {
  EditPageLayout,
  EditFieldLabel,
  EditFormTopSection,
  EditImageSection,
} from "../../../components/edit/EditPageLayout";

const imgFileTypes = ["image/gif", "image/jpeg", "image/png", "image/svg+xml"];

export default function UpdatePopupMessage({ homeAlert }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [values, setValues] = useState({ title: "", image_url: "" });
  const [imagePreview, setImagePreview] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [imageFileUrl, setImageFileUrl] = useState("");

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await popupMessage.findOne(instanceToken.token, id);
        setValues({
          title: response?.data?.title || "",
          image_url: response?.data?.image_url || "",
        });
      } catch (error) {
        console.error("Error fetching popup message:", error);
      }
    }
    fetchData();
  }, [id]);

  async function getImageUrl(imgData) {
    const response = await imageUpload.getImageUrl(
      instanceToken.token,
      imgData
    );
    const result = response.data;
    setImageFileUrl(result?.imageUploadUrl);
    setValues((prev) => ({
      ...prev,
      image_url: `https://axra.sgp1.digitaloceanspaces.com/CBLifeInsuranceLive/${result?.imageName}`,
    }));
  }

  const changeFile = async (e) => {
    if (e.target.files && e.target.files[0]) {
      const img = e.target.files[0];
      if (!imgFileTypes.includes(img.type)) {
        setErrors({
          image_url: "Please select image. (PNG, JPG, JPEG, GIF, ...)",
        });
        return;
      }
      if (img.size > 204800) {
        setErrors({
          image_url: "Image file size must be smaller than 200KB.",
        });
        return;
      }
      setImageFile(img);
      setImagePreview(URL.createObjectURL(img));
      setErrors({});
      getImageUrl(img);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", values.title || "");
    formData.append("image_url", values.image_url || "");

    try {
      setLoading(true);
      if (imageFile) {
        await imageUpload.uploadImage(imageFileUrl, imageFile);
      }
      await popupMessage.update(instanceToken.token, id, formData);
      homeAlert("Popup has been updated.", false);
      navigate("/popup-messages");
    } catch (error) {
      console.log(error);
      homeAlert("File Upload Failed!", true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <EditPageLayout
      title="Edit Popup Message"
      subtitle="Update popup image and title."
      breadcrumbs={[
        { label: "Popup Messages", path: "/popup-messages" },
        { label: `Popup (ID - ${id})`, path: `/popup-messages/${id}` },
        { label: "Edit" },
      ]}
      detailPath={`/popup-messages/${id}`}
      listPath="/popup-messages"
      loading={loading}
      submitLabel="Update"
      onSubmit={handleUpdate}
    >
      <EditFormTopSection
        image={
          <EditImageSection
            inputId="update-popup-image"
            imageUrl={values.image_url}
            imagePreview={imagePreview}
            onFileChange={changeFile}
            error={errors.image_url}
            recommendedSize="1920 × 1080 px, 16:9 aspect ratio, max 200KB"
            accept="image/png, image/jpeg, image/jpg, image/gif, image/svg+xml"
          />
        }
      >
        <div>
          <EditFieldLabel>Title (optional)</EditFieldLabel>
          <TextField
            fullWidth
            value={values.title || ""}
            onChange={(e) =>
              setValues({ ...values, title: e.target.value.trim() })
            }
            error={!!errors.title}
            helperText={errors.title}
          />
        </div>
      </EditFormTopSection>
    </EditPageLayout>
  );
}
